import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PasswordForgottenUpdatePage } from './password-forgotten-update';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    PasswordForgottenUpdatePage,
  ],
  imports: [
    IonicPageModule.forChild(PasswordForgottenUpdatePage),
    PipesModule,
    DirectivesModule,

  ],
})
export class PasswordForgottenUpdatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/password-forgotten-update/password-forgotten-update.module.ts